import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35a01a6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-back" }, null, -1))
const _hoisted_4 = { class: "text-back" }
const _hoisted_5 = { class: "pagination" }

import { ref, watch, onMounted, onBeforeUnmount } from 'vue';
import type { Ref } from 'vue'
import { storeToRefs } from 'pinia';
import { useInfo, useComic } from '@/store';
import { isMobile } from '@/hooks/useCheck';
import { useBackgroundUrl } from './useComicImg';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComicReader',
  setup(__props) {

_useCssVars(_ctx => ({
  "8c91508c": (_unref(bgComicReader).mobile),
  "fec27a72": (_unref(iconBackActive).mobile),
  "7b0a2e6d": (_unref(iconBack).mobile),
  "2331a97e": (_unref(iconArrowDown).mobile),
  "7a5c210b": (_unref(bgComicReader).pc),
  "2eb5cad0": (_unref(iconBackActive).pc),
  "3134493e": (_unref(iconBack).pc)
}))

const {
  bgComicReader,
  iconArrowDown,
  iconBack,
  iconBackActive,
} = useBackgroundUrl();
const { comics, showComicReader } = storeToRefs(useComic());
const { getTrans } = useInfo();
const { updateShowComicReader } = useComic();

const comicReader = ref();
const lastScrollY = ref(0);
const showController = ref(true);
const hideIconArrow = ref(false);
const isMobileLandscape = ref(false);
const controllerTimer: Ref<NodeJS.Timeout | null> = ref(null);
const currentPage = ref(1);
const textPagination = ref('');
const comicHeight = ref(0);

watch([currentPage, comics], (newValue) => {
  textPagination.value = getTrans('IW_PAGE')
    .replace('{num1}', String(newValue[0]))
    .replace('{num2}', String(newValue[1].length));
}, {
  immediate: true,
});

const forceShowController = () => {
  if (controllerTimer.value) {
    clearTimeout(controllerTimer.value);
  }
  showController.value = true;
}
const handleShowController = (updatedShowController: boolean) => {
  if (controllerTimer.value) {
    clearTimeout(controllerTimer.value);
  }
  if (updatedShowController) {
    showController.value = true;
    controllerTimer.value = setTimeout(() => {
      showController.value = false;
    }, 2000);
  } else {
    showController.value = updatedShowController;
  }
};
const handleScroll = () => {
  const scrollY = window.scrollY;
  if (lastScrollY.value > scrollY) {
    handleShowController(true);
  }
  if (!hideIconArrow.value) {
    hideIconArrow.value = true;
    localStorage.setItem('HIDE_COMIC_ICON_ARROW', 'true');
  }
  // using conditional operator to prevent currentPage from showing 0 when scrolling up on iOS
  currentPage.value = scrollY < comicHeight.value ? 1 : Math.floor(scrollY / comicHeight.value) + 1;
  if (comicReader.value.clientHeight <= scrollY + window.innerHeight + 2) {
    // 2px buffer for android device
    currentPage.value = comics.value.length;
  }
  lastScrollY.value = scrollY;
};
const handleResize = () => {
  const fontSize = isMobile.value ?
    window.innerWidth / 750 :
    window.innerWidth <= 750 ?
      window.innerWidth / 750 :
      Math.min(window.innerWidth / 1440, 1);
  const comicSize = isMobile.value ?
    window.innerWidth :
    window.innerWidth <= 750 ?
      window.innerWidth :
      516 * fontSize;
  comicHeight.value = comicSize * 4594 / 3031; // cover size: 3031px x 4594px
};
const handleOrientationChange = () => {
  isMobileLandscape.value = !!isMobile.value && window.innerWidth > window.innerHeight;
};
const handleComicReaderClick = () => {
  if (isMobile.value) {
    handleShowController(true);
  }
};

onMounted(async () => {
  hideIconArrow.value = !!localStorage.getItem('HIDE_COMIC_ICON_ARROW');
  handleResize();
  handleShowController(true);
  handleOrientationChange();
  window.addEventListener('resize', handleResize);
  window.addEventListener('scroll', handleScroll);
  window.addEventListener('orientationchange', handleOrientationChange);
  comicReader.value.scrollTop = 0;
});
onBeforeUnmount(async () => {
  window.removeEventListener('resize', handleResize);
  window.removeEventListener('scroll', handleScroll);
});

return (_ctx: any,_cache: any) => {
  return (_unref(showComicReader))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "comicReader",
        ref: comicReader,
        class: _normalizeClass(['comic-reader', {
      mobileLandscape: isMobileLandscape.value,
    }]),
        onClick: handleComicReaderClick
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(comics), (comic, comicIdx) => {
          return (_openBlock(), _createElementBlock("img", {
            key: comicIdx,
            src: comic,
            loading: "lazy",
            class: "comic"
          }, null, 8, _hoisted_1))
        }), 128)),
        _createElementVNode("div", {
          class: _normalizeClass(['controller', {
        hide: !showController.value,
      }]),
          onMouseenter: forceShowController,
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (handleShowController(true)))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "btn-back",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(updateShowComicReader)(false)))
            }, [
              _hoisted_3,
              _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(getTrans)('IW_BACK')), 1)
            ]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(textPagination.value), 1)
          ])
        ], 34),
        _createElementVNode("div", {
          class: _normalizeClass(['icon-arrow', { hide: hideIconArrow.value }])
        }, null, 2)
      ], 2))
    : _createCommentVNode("", true)
}
}

})